import React from 'react';
import {style, classes} from './doppe-viewer-on-page-actions-divider.st.css';
import {OmitStrict, PartiallyOptional, PickKeys} from "@wix/devzai-utils-common";
import {DoppeViewerDivider, DoppeViewerDividerSkin} from "../doppe-viewer-divider/doppe-viewer-divider";

export const DoppeViewerOnPageActionsDivider = React.memo(function DoppeViewerOnPageActionsDivider (props: DoppeViewerOnPageActionsDivider.Props) {
    const {
        beforeFramedAction,
        afterFramedAction,

        className,
        ...restProps
    } = props;

    return (
        <DoppeViewerDivider
            {...restProps}
            className={style(classes.root, {
                beforeFramedAction: beforeFramedAction,
                afterFramedAction: afterFramedAction,
            }, className)}
            skin={DoppeViewerDividerSkin.HorizontalLine}
        />
    );
});

export namespace DoppeViewerOnPageActionsDivider {

    type OmittedProps = PickKeys<DoppeViewerDivider.Props, 'skin'>;
    type PropsWithDefaultValues = PickKeys<DoppeViewerDivider.Props, never>

    export interface Props extends PartiallyOptional<OmitStrict<DoppeViewerDivider.Props, OmittedProps>, PropsWithDefaultValues> {
        beforeFramedAction: boolean;
        afterFramedAction: boolean;
    }
}